import React from 'react';
import { Button } from '../shared/Button';
import { motion } from 'framer-motion';
import { ArrowDownIcon } from 'lucide-react';
export const HeroSection = () => {
  return <section className="w-full bg-[#231232] text-white py-16 md:py-32 relative" data-id="element-165">
      <div className="absolute inset-0 overflow-hidden" data-id="element-166">
        <motion.div animate={{
        y: [0, -10, 0],
        opacity: [0.08, 0.12, 0.08]
      }} transition={{
        duration: 15,
        repeat: Infinity,
        ease: 'linear'
      }} className="absolute inset-0 bg-[radial-gradient(circle_at_center,_#FFC501_1px,_transparent_1px)] bg-[length:40px_40px]" data-id="element-167" />
      </div>
      <div className="relative w-full px-4 sm:px-6 lg:px-8" data-id="element-168">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="relative backdrop-blur-xl bg-gradient-to-br from-white/5 via-white/[0.02] to-transparent rounded-2xl p-6 sm:p-12 lg:p-16 border border-white/10 shadow-xl max-w-7xl mx-auto" data-id="element-169">
          <div className="relative z-10 max-w-4xl mx-auto" data-id="element-170">
            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} className="font-outfit text-3xl sm:text-5xl lg:text-6xl font-bold mb-10 sm:mb-8 leading-tight text-center tracking-tight" data-id="element-171">
              <span className="bg-gradient-to-r from-[#FFFCE7] to-[#FFC501] bg-clip-text text-transparent" data-id="element-172">
                Land better offers in 8-12 weeks
              </span>
            </motion.h1>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.4
          }} className="font-manrope text-xl sm:text-2xl mb-14 sm:mb-12 text-[#FFFCE7]/90 text-center leading-relaxed" data-id="element-173">
              ApplyPass Platinum is our elite 1:1 career transformation program
              — proven to help senior software engineers command higher compensation and
              unlock strategic control over their career trajectory.
            </motion.p>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.6
          }} className="flex flex-col sm:flex-column items-center justify-center gap-8 sm:gap-6" data-id="element-174">
              <Button variant="gradient-primary" size="lg" href="/start" className="w-full sm:w-auto text-lg sm:text-xl font-semibold" data-id="element-175">
                Book Strategy Call
              </Button>
              <div className="text-center sm:text-left" data-id="element-176">
                <p className="text-white/80 text-lg" data-id="element-177">
                  Limited to 12 clients per quarter.{' '}
                  <span className="text-[#FFC501] font-semibold" data-id="element-178">
                    4 spots remaining
                  </span>
                </p>
              </div>
            </motion.div>
          </div>
          {/* Subtle gradients */}
          <div className="absolute inset-0 rounded-2xl overflow-hidden" data-id="element-179">
            <div className="absolute -bottom-1/4 -right-1/4 w-[100%] h-[100%] bg-gradient-to-tl from-[#6805DA]/15 via-[#6805DA]/5 to-transparent opacity-60 blur-xl" data-id="element-180" />
            <div className="absolute -top-1/4 -left-1/4 w-[100%] h-[100%] bg-gradient-to-br from-[#FFC501]/10 via-[#FFC501]/5 to-transparent opacity-40 blur-xl" data-id="element-181" />
            <div className="absolute inset-0 bg-[#231232]/10 backdrop-blur-sm" data-id="element-182" />
          </div>
        </motion.div>
      </div>
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2" data-id="element-183">
        <Button variant="ghost" href="#trusted-by" className="text-white/60 hover:text-white flex flex-col items-center gap-2" data-id="element-184">
          <span className="text-sm font-medium" data-id="element-185">See the results</span>
          <ArrowDownIcon className="animate-bounce" size={20} data-id="element-186" />
        </Button>
      </div>
    </section>;
};